
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center pt-20"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.97) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.6) 100%), url('https://public.readdy.ai/ai/img_res/33fb615fcfa634b04c854030092bf821.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-indigo-100 text-indigo-600 rounded-full text-sm font-semibold whitespace-nowrap">
              Secure VPN Solutions
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Protect Your Digital Privacy
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              DUO FORM delivers enterprise-grade VPN technology that safeguards your online activities, encrypts your data, and ensures complete anonymity across all your devices with military-grade encryption protocols.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToContact}
                className="px-8 py-4 bg-indigo-600 text-white rounded-full font-semibold hover:bg-indigo-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Get Started
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById('features');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 bg-white text-indigo-600 rounded-full font-semibold hover:bg-gray-50 transition-all border-2 border-indigo-600 cursor-pointer whitespace-nowrap"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
